<h1 mat-dialog-title>Login</h1>
<div mat-dialog-content>
  <p>{{ text }}</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onClick()">{{ buttonText }}</button>
</div>
